/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reward_Reveal_Bonus_TitleInputs */

const en_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double rewards on your first purchase!`)
};

const ar_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكافآت مضاعفة عند الشراء الأول!`)
};

const de_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Belohnungen beim ersten Kauf!`)
};

const es_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Recompensas dobles en tu primera compra!`)
};

const fr_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récompenses doublées pour votre premier achat !`)
};

const it_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricompense doppie al primo acquisto!`)
};

const ja_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初回購入で報酬2倍！`)
};

const ko_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`첫 구매 보상 2배!`)
};

const pt_br_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recompensas em dobro na primeira compra!`)
};

const ru_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Двойная награда за первую покупку!`)
};

const th_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับรางวัลสองเท่าเมื่อซื้อครั้งแรก!`)
};

const tr_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk satın almada iki kat ödül!`)
};

const zh_cn_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首购双倍奖励！`)
};

const zh_tw_reward_reveal_bonus_title = /** @type {(inputs: Reward_Reveal_Bonus_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首購雙倍獎勵！`)
};

/**
* | output |
* | --- |
* | "Double rewards on your first purchase!" |
*
* @param {Reward_Reveal_Bonus_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const reward_reveal_bonus_title = /** @type {((inputs?: Reward_Reveal_Bonus_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reward_Reveal_Bonus_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reward_reveal_bonus_title(inputs)
	if (locale === "ar") return ar_reward_reveal_bonus_title(inputs)
	if (locale === "de") return de_reward_reveal_bonus_title(inputs)
	if (locale === "es") return es_reward_reveal_bonus_title(inputs)
	if (locale === "fr") return fr_reward_reveal_bonus_title(inputs)
	if (locale === "it") return it_reward_reveal_bonus_title(inputs)
	if (locale === "ja") return ja_reward_reveal_bonus_title(inputs)
	if (locale === "ko") return ko_reward_reveal_bonus_title(inputs)
	if (locale === "pt_br") return pt_br_reward_reveal_bonus_title(inputs)
	if (locale === "ru") return ru_reward_reveal_bonus_title(inputs)
	if (locale === "th") return th_reward_reveal_bonus_title(inputs)
	if (locale === "tr") return tr_reward_reveal_bonus_title(inputs)
	if (locale === "zh_cn") return zh_cn_reward_reveal_bonus_title(inputs)
	return zh_tw_reward_reveal_bonus_title(inputs)
});